/**
 * @generated SignedSource<<c1ec444014312b244721a6e2acb8ebb7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "resellerPId"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "resellerpid",
        "variableName": "resellerPId"
      }
    ],
    "concreteType": "PartnerCommissionProgramSummary",
    "kind": "LinkedField",
    "name": "getpartnercommissionprogramsummary",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "resellerPId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "commProgramName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "partnerId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "partnerName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "cpId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vendorId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "vendorName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "totalAmtPaid",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "amtPending",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RcpCommViewQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RcpCommViewQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a54dc323bc9745dd4eda9924f76286fe",
    "id": null,
    "metadata": {},
    "name": "RcpCommViewQuery",
    "operationKind": "query",
    "text": "query RcpCommViewQuery(\n  $resellerPId: UUID!\n) {\n  getpartnercommissionprogramsummary(resellerpid: $resellerPId) {\n    resellerPId\n    commProgramName\n    partnerId\n    partnerName\n    cpId\n    vendorId\n    vendorName\n    totalAmtPaid\n    amtPending\n  }\n}\n"
  }
};
})();

node.hash = "9efddb7977efd4c1ab752b7a1261420b";

module.exports = node;
